import { useTranslate } from "@tolgee/react";
import {
  ControlledCombobox,
  ControlledDatePicker,
  ControlledTextArea,
  ControlledTextField,
} from "@/components/Form";
import { PsProductFieldTypeEnum } from "@/config/apiClient";
import { type TechnicalFieldProps } from "../QualifyDrawerForm.types";

const DEFAULT_PLACEHOLDER = "N/A";
export const TechnicalField = ({ field }: TechnicalFieldProps) => {
  const { t } = useTranslate();

  if (field.type === PsProductFieldTypeEnum.DropdownList) {
    return (
      <ControlledCombobox
        key={field.id}
        name={`fields.${field.id}`}
        placeholder={DEFAULT_PLACEHOLDER}
        label={field.name}
        options={
          field.values?.map((option) => ({
            label: option.name,
            name: option.name,
            id: option.value_id,
            textValue: `${option.value_id}`,
          })) || []
        }
      />
    );
  }
  if (field.type === PsProductFieldTypeEnum.Text) {
    return (
      <ControlledTextField
        key={field.id}
        name={`fields.${field.id}`}
        placeholder={DEFAULT_PLACEHOLDER}
        label={field.name}
      />
    );
  }
  if (field.type === PsProductFieldTypeEnum.Description) {
    return (
      <ControlledTextArea
        key={field.id}
        name={`fields.${field.id}`}
        placeholder={DEFAULT_PLACEHOLDER}
        label={field.name}
      />
    );
  }
  if (field.type === PsProductFieldTypeEnum.Date) {
    return (
      <ControlledDatePicker
        key={field.id}
        name={`fields.${field.id}`}
        placeholder={DEFAULT_PLACEHOLDER}
        label={field.name}
      />
    );
  }
  if (field.type === PsProductFieldTypeEnum.CheckBox) {
    return (
      <ControlledCombobox
        key={field.id}
        name={`fields.${field.id}`}
        label={field.name}
        placeholder={DEFAULT_PLACEHOLDER}
        options={[
          {
            label: t("common.yes"),
            id: "true",
            textValue: "true",
          },
          {
            label: t("common.no"),
            id: "false",
            textValue: "false",
          },
        ]}
      />
    );
  }
  if (
    [PsProductFieldTypeEnum.Decimal, PsProductFieldTypeEnum.Numerical].includes(
      field.type
    )
  ) {
    return (
      <ControlledTextField
        type="number"
        key={field.id}
        name={`fields.${field.id}`}
        placeholder={DEFAULT_PLACEHOLDER}
        label={field.name}
      />
    );
  }
  return (
    <div>
      Unhandled type {field.type} ({field.name})
    </div>
  );
};
